<template>
  <div>
    <keep-alive :include='includes' :max="5">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
export default {
  name: "cagechild",
  
 
  data() {
    return {};
  },
  computed: {
    ...mapState({
       includes: state => state.includes,
     }),
  },

};
</script>

<style lang='scss' scoped>
</style>
